export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/EG-b322f9f5f57109579c650dab94b0d51d.png";